<template>
    <div @click="clk" id="download-btn" :class="{ mg: mg }">
        <svg style="width: 20px;
    height: 20px;" data-v-1616d4b4="" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="icon">
            <path data-v-1616d4b4="" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline data-v-1616d4b4="" points="7 10 12 15 17 10"></polyline>
            <line data-v-1616d4b4="" x1="12" y1="15" x2="12" y2="3"></line>
        </svg> {{ value }}
    </div>
</template>
<script>

export default {
    props: ['value', 'mg'],
    methods: {
        clk() {
            if (this.$route.name !== 'download') {
                window.location.href = '/download/';
            } else {
                this.$emit('download');
            }
        }
    },
    computed: {

    }
}
</script>
<style lang="scss" scoped>
.mg {
    margin: 30px auto;
}

#download-btn {
    padding: 0 30px;
    font-size: 20px;
    text-align: center;
    border-radius: 20px;
    color: white;
    height: 40px;
    line-height: 40px;
    background: #25b864;
    cursor: pointer;
    width: fit-content;font-weight: 700;
}
</style>
